// src/components/CampaignTable.jsx
import React from 'react';
import { Eye } from 'lucide-react';

const formatDate = (isoDate) => {
  const date = new Date(isoDate);
  const day = date.getDate().toString().padStart(2, '0');
  const month = date.toLocaleString('en-US', { month: 'short' });
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const CampaignTable = ({ campaigns, onSeeDetails }) => {
  return (
    <div className="overflow-x-auto rounded shadow bg-white">
      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-blue-100">
            <th className="p-3 text-left text-blue-700">Campaign ID</th>
            <th className="p-3 text-left text-blue-700">Initiated On</th>
            <th className="p-3 text-left text-blue-700">Type</th>
            <th className="p-3 text-left text-blue-700"># Participants</th>
            <th className="p-3 text-left text-blue-700"># Completed</th>
            <th className="p-3 text-left text-blue-700">Status</th>
            <th className="p-3 text-left text-blue-700">Action</th>
          </tr>
        </thead>
        <tbody>
          {campaigns && campaigns?.length>0 && campaigns.map((campaign) => (
            <tr
              key={campaign.campaign_id}
              className="border-b border-blue-100 hover:bg-blue-50 transition"
            >
              <td className="p-3" data-id={campaign.campaign_id}>{campaign.campaign_id}</td>
              <td className="p-3">{formatDate(campaign.initiated_on)}</td>
              <td className="p-3">{campaign.type}</td>
              <td className="p-3">{campaign.total_participants}</td>
              <td className="p-3">{campaign.participants_completed}</td>
              <td className="p-3">
                <span
                  className={`px-2 py-1 rounded text-xs font-semibold ${
                    campaign.status === 'Completed'
                      ? 'bg-green-100 text-green-700'
                      : campaign.status === 'Active'
                      ? 'bg-yellow-100 text-yellow-700'
                      : 'bg-gray-100 text-gray-600'
                  }`}
                >
                  {campaign.status}
                </span>
              </td>
              <td className="p-3">
                <button
                  onClick={() => onSeeDetails(campaign.campaign_id)}
                  className="text-blue-600 border border-blue-300 px-3 py-1 rounded-md hover:bg-blue-100 flex items-center"
                >
                  <Eye className="mr-2 h-4 w-4" />
                  Details
                </button>
              </td>
            </tr>
          ))}
          { (campaigns?.length === 0 || !campaigns) ? (
            <tr>
              <td colSpan="7" className="text-center text-gray-500 p-4">
                No campaigns found
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
};

export default CampaignTable;
